/**
 * @generated SignedSource<<3da5a0a56e8cfc863f5cdd24f160cb42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_user" | "PdpSharedBuyerIncentivesCompact_user" | "PdpSharedCallDealerCta_user" | "PdpSharedDealerDetailsHeader_user" | "PdpSharedSellerTabsVariant_user">;
  readonly " $fragmentType": "PdpRespDealerDetails_user";
};
export type PdpRespDealerDetails_user$key = {
  readonly " $data"?: PdpRespDealerDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerIncentivesCompact_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e84249429b10aeadcd6be03af555443b";

export default node;
